import styled from 'styled-components';

export const $NotOpenForClaimsReasonMessage = styled.div`
  font-style: italic;
  display: flex;
  align-items: center;
  gap: 4px;
`;
